"use client"

import React, { useState, useEffect } from "react"
import { usePathname } from "next/navigation"

import NavLink from "@packages/web/components/NavLink"
import BackLink from "@packages/web/components/BackLink"
import NavMenu, { type TasksNavConfig } from "@packages/web/components/NavMenu"

import BackofficeBrand from "@/components/BackofficeBrand"

export type { TasksNavConfig }

export default function Header({
  noBacklink,
  tasksConfig,
}: {
  noBacklink?: boolean
  tasksConfig?: TasksNavConfig
} = {}) {
  const [isScrolled, setIsScrolled] = useState(false)
  const pathname = usePathname()
  const showBackLink = pathname.split("/").length > 2 && !noBacklink

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0)
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <header className={`fixed top-0 left-0 grid grid-cols-[1fr_auto_1fr] items-center w-full z-2001 px-2 h-(--header-height) pointer-events-none transition-all duration-300 ${isScrolled ? "shadow-sm bg-background backdrop-blur-md" : "bg-background/90"}`}>
      <NavLink to="/" variant="secondary" className="!bg-transparent hover:!bg-transparent/80 pl-0 w-fit pointer-events-auto" aria-label="Ernest backoffice — accueil">
        <BackofficeBrand iconSize={40} />
      </NavLink>
      <div className="flex justify-center pointer-events-auto">
        {showBackLink && <BackLink />}
      </div>
      <div className="pointer-events-auto justify-self-end">
        <NavMenu tasksConfig={tasksConfig} />
      </div>
    </header>
  )
}
